import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Transaction } from './transaction.model';
import capitalize from 'lodash/capitalize';

export interface TransactionsState extends EntityState<Transaction> {
    ui: {
        lastEntryByUser: Date;
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'transactions', idKey: 'transactionId', resettable: true })
export class TransactionsStore extends EntityStore<TransactionsState> {
    constructor() {
        super({
            ui: {
                lastEntryByUser: null
            }
        });
    }

    akitaPreAddEntity(transaction: Transaction) {
        let modifiedTransaction = { ...transaction };
        if (!transaction.settlementTimestamp) {
            const transactionDate = new Date(transaction.transactionDateTime);
            const importedAtDate = new Date(transaction.importedAt);
            const settlementDate = new Date(transaction.settlementDate);
            const transactionMilliseconds = transactionDate.getMilliseconds();
            const hours =
                transactionMilliseconds !== 0
                    ? transactionDate.getHours()
                    : importedAtDate.getHours();
            const minutes =
                transactionMilliseconds !== 0
                    ? transactionDate.getMinutes()
                    : importedAtDate.getMinutes();
            const seconds =
                transactionMilliseconds !== 0
                    ? transactionDate.getSeconds()
                    : importedAtDate.getSeconds();
            const milliseconds =
                transactionMilliseconds !== 0
                    ? transactionMilliseconds
                    : importedAtDate.getMilliseconds();

            const settlementYear = settlementDate.getFullYear();
            const settlementMonth = settlementDate.getMonth();
            const settlementDay = settlementDate.getDate();
            const settlementTimestamp = new Date(
                settlementYear,
                settlementMonth,
                settlementDay,
                hours,
                minutes,
                seconds,
                milliseconds
            ).getTime();

            let description = getDescription(transaction);
            `${transaction.instrumentName}${transaction.transactionId}`; //`transaction.description${transaction.transactionId}`; // TODO - get description from transaction;
            modifiedTransaction = {
                ...transaction,
                transactionTimestamp: transactionDate.getTime(),
                settlementTimestamp,
                amount: transaction.nominal * transaction.transactionPrice,
                importedTimestamp: importedAtDate.getTime(),
                description
            };
        }
        return modifiedTransaction;
    }

    akitaPreUpdateEntity(prevTransaction: Transaction, nextTransaction: Transaction) {
        // return the same entity or modify it
        return nextTransaction;
    }
}

const temp = {
    version: '1.2.0',
    meta: {
        ledgerType: 5,
        ledgerId: 1,
        ledgerName: 'Cashs',
        ledgerDescription: 'Cash'
    }
};

const newTemp = {
    version: '1.1.0',
    meta: {
        ledgerTypes: ['Foo'],
        ledgerId: 1,
        ledgerName: 'Cashs',
        ledgerDescription: 'Cash',
        ledgerType: ['Foo']
    }
};

const getDescription = (transaction: Transaction) => {
    let description = '';
    switch (transaction.instrument.type) {
        case 'CASH':
            description = `Cash ${transaction.transactionType.toLowerCase()} (${
                transaction.transactionCurrency
            })`;
            break;
        case 'EQUITY':
            const action = capitalize(transaction.transactionType);
            description = `${action} ${transaction.instrument.name} (${transaction.instrument.symbol})`;
            break;
    }
    return description;
};
